import { render } from "./CourseDetailView.vue?vue&type=template&id=3657caa0&scoped=true"
import script from "./CourseDetailView.vue?vue&type=script&lang=js"
export * from "./CourseDetailView.vue?vue&type=script&lang=js"

import "./CourseDetailView.vue?vue&type=style&index=0&id=3657caa0&scoped=true&lang=css"

import exportComponent from "D:\\Code_projects\\maria_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3657caa0"]])

export default __exports__